import { constantCreator } from '~/utils/constantsCreator';
import api from '~/utils/api';

const constant = constantCreator('search');
const SEARCH = constant('SEARCH', true);
const GET_HISTORY = constant('GET_HISTORY', true);
const FILTER_UPDATE = constant('FILTER_UPDATE');
const FILTER_UPDATE_AND_LOG = constant('FILTER_UPDATE_AND_LOG');
const FILTER_CLAER = constant('FILTER_CLAER');
const LOG_OPEN_FILTER = constant('LOG_OPEN_FILTER');
const OPEN_MOBILE_FILTER = constant('OPEN_MOBILE_FILTER');
const LOG_CLEAR_FULL_TEXT_SEARCH = constant('LOG_CLEAR_FULL_TEXT_SEARCH');
const LOG_SUBMIT_FULL_TEXT_SEARCH = constant('LOG_SUBMIT_FULL_TEXT_SEARCH', true);

const initialState = {
  data: [],
  searching: true,
  appending: true,
  filtering: true,
  filter: {},
  isEnd: false,
  history: {},
  isOpenMobileFilter: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH.PENDING:
      return {
        ...state,
        data: action.append ? state.data : [],
        searching: true,
        appending: action.append,
        filtering: action.filter,
      };
    case SEARCH.RESOLVED:
      if (typeof window !== 'undefined' && window && window.scrollTo && !action.append) {
        window.scrollTo(0, 0);
      }
      return {
        ...state,
        data: action.append ? [...state.data, ...action.data] : action.data,
        isEnd: action.data.length < 10,
        searching: false,
        appending: false,
        filtering: false,
      };
    case SEARCH.REJECTED:
      return {
        ...state,
        searching: true,
        appending: false,
        filtering: false,
        error: action.data,
      };
    case GET_HISTORY.RESOLVED:
      return {
        ...state,
        history: action.data,
      };
    case FILTER_UPDATE:
    case FILTER_UPDATE_AND_LOG:
      return {
        ...state,
        filter: action.filterData,
      };
    case FILTER_CLAER:
      return {
        ...state,
        filter: {},
      };
    case OPEN_MOBILE_FILTER:
      return {
        ...state,
        isOpenMobileFilter: action.open,
      };
    default:
      return state;
  }
};

export default reducer;

export const actions = {
  search: (data, append = false, filter = false) => {
    const queryStr = [
      `city=${data.city || 'Bangkok'}`,
      `skip=${data.skip || 0}&limit=10`,
    ];
    if (data.focus) {
      queryStr.push(`focus=${data.focus}`);
    }
    if (data.activities) {
      queryStr.push(`activities=${data.activities}`);
    }
    if (data.starting_time) {
      queryStr.push(`starting_time=${data.starting_time}`);
    }
    if (data.price_from && data.price_to) {
      queryStr.push(`price_from=${data.price_from}&price_to=${data.price_to}`);
    }
    return {
      type: SEARCH,
      promise: api.get(`/experience/types/${data.type}?${queryStr.join('&')}`),
      append,
      filter,
    };
  },
  getHistory: () => ({
    type: GET_HISTORY,
    promise: api.get('/experience/history'),
  }),
  updateFilter: (filterData, key, value, log = false) => {
    return {
      type: log ? FILTER_UPDATE_AND_LOG : FILTER_UPDATE,
      filterData,
      key,
      value
    };
  },
  clearFilter: () => ({
    type: FILTER_CLAER,
  }),
  logOpenFilter: (filterType) => ({
    type: LOG_OPEN_FILTER,
    filterType,
  }),
  openMobileFilter: (open = true) => ({
    type: OPEN_MOBILE_FILTER,
    open,
  }),
  logClearFullTextSearch: (text) => ({
    type: LOG_CLEAR_FULL_TEXT_SEARCH,
    text,
  }),
  logSubmitFullTextSearch: (text) => ({
    type: LOG_SUBMIT_FULL_TEXT_SEARCH,
    text,
    promise: api.post('/logs', {
      namespace: 'Experience Search',
      title: 'Submit Full Text Search',
      data: {
        category: 'Experience Search',
        name: 'Submit Full Text Search',
        origin: 'experience',
        path: window && window.location && window.location.pathname,
        providers: 'database',
        text,
      }
    }),
  })
};

export const analytics = {
  [SEARCH.RESOLVED]: () => ({ name: 'Searched', category: 'Search' }),
  [LOG_OPEN_FILTER]: action => ({
    name: 'Open Filter', category: 'Experience Search', filterType: action.filterType, providers: 'database'
  }),
  [FILTER_UPDATE_AND_LOG]: action => ({
    name: 'Update Filter', category: 'Experience Search', filterType: action.filterData, key: action.key, value: action.value, providers: 'database'
  }),
  [FILTER_CLAER]: () => ({name: 'Clear Filter', category: 'Experience Search', providers: 'database'}),
  [OPEN_MOBILE_FILTER]: action => ({name: action.open ? 'Open Mobile Filters' : 'Close Mobile Filters', category: 'Experience Search', providers: 'database'}),
  [LOG_CLEAR_FULL_TEXT_SEARCH]: action => ({
    name: 'Clear Full Text Search', category: 'Experience Search', providers: 'database', text: action.text
  }),
  // [LOG_SUBMIT_FULL_TEXT_SEARCH]: action => ({name: 'Submit Full Text Search', category: 'Experience Search', providers: 'database', text: action.text}),
};
